import {
  Edit, TableRows,
} from '@styled-icons/material';
import classNames from 'classnames';
import { FormElement } from '@typedream/core';
import shallow from 'zustand/shallow';
import styles from '../SideToolbar.module.css';
import { useDreamEditorStore } from '../../../plugins/store';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { getTPlugin, useTPlateEditorRef } from '../../../plate';
import { ELEMENT_FORM } from '../../../pluginKeys';
import { FormPluginOptions } from '../../../nodes/form/types';

function Form() {
  const editor = useTPlateEditorRef();

  const [formID] = useDreamEditorStore(() => {
    const entry = getSelectedElementEntry<FormElement>(editor);

    if (!entry) return ['', []];

    const [node] = entry;
    const { form_id } = node;

    return [form_id];
  }, shallow);

  const { options } = getTPlugin<FormPluginOptions>(editor, ELEMENT_FORM);
  const { toolbarActions } = options || {};

  return (
    <div className={styles.section}>
      <div className={styles.label}>Form</div>
      <button
        type="button"
        className={styles.button}
        disabled={!formID}
        onClick={() => toolbarActions?.handleGoEditForm?.(formID)}
        data-testid="ToolbarEditFormButton"
      >
        <Edit size={16} className="mr-2" />
        Edit form
      </button>

      <button
        type="button"
        className={classNames(styles.button, 'mt-1')}
        disabled={!formID}
        onClick={() => toolbarActions?.handleGoFormSubmissions?.(formID)}
        data-testid="ToolbarFormSubmissionButton"
      >
        <TableRows size={16} className="mr-2" />
        Form Submission
      </button>
    </div>
  );
}

export default Form;
